import { ApiService } from './api';
import { User, CreateUserData, UpdateUserData } from '@/models';
import { ApiResponse } from '@/models/common';
import { ApiEndpoints, Endpoints } from '@/models/endpoints';

export class UserService {
  // Get all users (no filters, returns total data)
  static async getUsers(): Promise<ApiResponse<User[]>> {
    return ApiService.get<User[]>(ApiEndpoints.USERS);
  }

  // Get user by ID
  static async getUserById(id: string): Promise<ApiResponse<User>> {
    return ApiService.get<User>(Endpoints.getUser(id));
  }

  // Create new user
  static async createUser(userData: CreateUserData): Promise<ApiResponse<User>> {
    return ApiService.post<User>(ApiEndpoints.USERS, userData);
  }

  // Update user
  static async updateUser(id: string, userData: UpdateUserData): Promise<ApiResponse<User>> {
    return ApiService.put<User>(Endpoints.updateUser(id), userData);
  }

  // Delete user
  static async deleteUser(id: string): Promise<ApiResponse<{ message: string }>> {
    return ApiService.delete<{ message: string }>(Endpoints.deleteUser(id));
  }

  // Search users by username or email (client-side filtering)
  static async searchUsers(query: string): Promise<ApiResponse<User[]>> {
    return ApiService.get<User[]>(Endpoints.searchUsers(query));
  }

  // Bulk delete users
  static async bulkDeleteUsers(ids: string[]): Promise<ApiResponse<{ message: string; deletedCount: number }>> {
    return ApiService.post<{ message: string; deletedCount: number }>(ApiEndpoints.USERS_BULK_DELETE, { ids });
  }

  // Change user password
  static async changePassword(id: string, currentPassword: string, newPassword: string): Promise<ApiResponse<{ message: string }>> {
    return ApiService.post<{ message: string }>(Endpoints.changeUserPassword(id), {
      currentPassword,
      newPassword
    });
  }

  // Reset user password
  static async resetPassword(id: string): Promise<ApiResponse<{ message: string; temporaryPassword: string }>> {
    return ApiService.post<{ message: string; temporaryPassword: string }>(Endpoints.resetUserPassword(id));
  }
} 